// extracted by mini-css-extract-plugin
module.exports = {"screenShareHeader":"ScreenShareHeader_screenShareHeader__1Hveg","stopButton":"ScreenShareHeader_stopButton__kY8UL","description":"ScreenShareHeader_description__1msao"};